export default {
	en: {
		translation: {
			facebook: {
				no_photos: "No photos...",
				no_auth_title: "Upload files from your Facebook account.",
				no_auth_action: "Connect to Facebook",
				no_auth_statement: "We will not post anything without your permission.",
				album_subtitle: "{{count}} photos",
				menu: {
					uploaded: "Your Photos",
					tagged: "Photos of You",
					albums: "Albums",
				},
			},
		},
	},
};
